import * as Yup from 'yup';

export const phoneNumberRegex = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;

export const phoneNumberValidation = Yup.string()
  .matches(phoneNumberRegex, 'Invalid phone number')
  .max(17, 'Phone number must be less than 17 characters')
  .min(15, 'Phone number must be at least 15 characters');
